export module MPCProductsCounter {
    ///count might be changed later by ajax loading
    ///e.g. when you navigate via MHS to the page, the URL has no savKey parameter, and the page then ajax-loads the localStorage data and updates the counter
    export class ProductsCounter {
        private productsCounterValue: HTMLElement;

        constructor(carousel: HTMLElement) {
            this.productsCounterValue = carousel.querySelector('.products-counter .counter-value');
        }

        public updateProductsCounter(value: number): void {
            this.productsCounterValue.innerHTML = value.toString();
        }
    }
}